import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-title">Здоров'я — це наше все!</div>

      <div className="footer-content">
        <div>Контактна інформація:</div>
        <div>📞 +380991972592</div>
        <div>✉ alionasamchenko@ukr.net</div>
        <div>📍 м. Кам'янське, Дніпропетровська обл., Україна</div>
      </div>
    </footer>
  );
}

export default Footer;